/* eslint-disable react-hooks/exhaustive-deps */
import {
  DeleteOutlined,
  EditOutlined,
  FileAddOutlined,
  InboxOutlined,
  LeftOutlined,
  LoadingOutlined,
  RightOutlined,
  SaveOutlined
} from '@ant-design/icons';
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Form,
  InputNumber,
  Modal,
  Row,
  Space,
  Spin,
  Switch,
  Tag,
  Typography,
  Upload,
  message
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import Dragger from 'antd/lib/upload/Dragger';
import moment from 'moment';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { useParams } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import CardDocumentPreview360 from '../../components/CardDocumentPreview360';
import Image360 from '../../components/Image360';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import UserContext from '../../context/user-context';
import {
  ORDEN_ESTADOS_VERIFICACION_AUTORIZACION,
  errorHandler,
  getDescripcionDocumento
} from '../../utils';
import { instanceRef } from '../../utils/axios';
import AutorizacionDatos from './AutorizacionDatos';
import AutorizacionDatosFiscal from './AutorizacionDatosFiscal';
import AutorizacionDatosVehiculo from './AutorizacionDatosVehiculo';
import Historial from './Historial';
import Cotizacion from './flujos/Cotizacion';
import Solicitud from './flujos/Solicitud';

const { Title } = Typography;
const { Panel } = Collapse;

const compareJSONObjects = (obj1, obj2) => {
  let existeDiferencia = false;
  for (const key in obj1) {
    if (
      Object.prototype.hasOwnProperty.call(obj1, key) &&
      key !== 'fechaNacimiento'
    ) {
      if (key in obj2 && obj1[key] !== obj2[key]) {
        existeDiferencia = true;
        break;
      }
      if (
        key === 'fechaNacimiento' &&
        moment(obj1.fechaNacimiento).format('YYYY-MM-DD') !==
          moment(obj2.fecha_nacimiento).format('YYYY-MM-DD')
      ) {
        existeDiferencia = true;
        break;
      }
    }
  }
  return existeDiferencia;
};

const AutorizacionVerify = () => {
  const { token } = useParams();
  const { user } = useContext(UserContext);
  const [autorizacion, setAutorizacion] = useState(null);
  const [asignacion, setAsignacion] = useState(false);
  const [solicitud, setSolicitud] = useState(null);
  const [solicitante, setSolicitante] = useState({});
  const [documentos, setDocumentos] = useState(null);
  const [formularios, setFormularios] = useState(null);
  const [aseguradoraProducto, setAseguradoraProducto] = useState(null);
  const [documento1, setDocumento1] = useState('');
  const [documentosAdicionales, setDocumentosAdicionales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [cotizaciones, setCotizaciones] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [dialogConfig, setDialogConfig] = useState(false);
  const [loadingBefore, setLoadingBefore] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [comentarioDet, setComentarioDet] = useState('');
  const [showComentario, setShowComentario] = useState(false);
  const [descuentosRecargosTecnicos, setDescuentosRecargosTecnicos] = useState(
    0
  );
  const [
    FormPersonalDatosActualizados,
    setFormPersonalDatosActualizados
  ] = useState();
  const [
    FormVehiculoDatosActualizados,
    setFormVehiculoDatosActualizados
  ] = useState();
  const [
    FormFiscalDatosActualizados,
    setFormFiscalDatosActualizados
  ] = useState();
  const [
    descuentosRecargosAdministrativos,
    setDescuentosRecargosAdministrativos
  ] = useState(0);
  const [gastosAdministrativos, setGastosAdministrativos] = useState(0);
  const [utilidad, setUtilidad] = useState(0);
  const [comision, setComision] = useState(0);
  const [gastosCobranzas, setGastosCobranzas] = useState(0);
  // const [usuario, setUsuario] = useState(null);
  const [accion, setAccion] = useState(null);
  const [form, setForm] = useState(null);
  const [habilitarBotonAprobar, setHabilitarBotonAprobar] = useState(true);
  const [
    observacionAutorizacionDatos,
    setObservacionesAutorizacionDatos
  ] = useState();
  const [datosConfirmados, setDatosConfirmados] = useState(false);
  const [visible, setVisible] = useState(false);

  const [formPersonal] = Form.useForm();
  const [formFiscal] = Form.useForm();
  const [formVehiculo] = Form.useForm();

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const formatosDoc =
    'image/jpeg,image/heif,image/heic, image/png, application/pdf';

  async function beforeUploadPDF(file, setLoadingImagen) {
    setLoadingImagen(true);
    const isPdf = file.type === 'application/pdf';
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/heif' ||
      file.type === 'image/heic' ||
      file.type === 'image/png';

    if (!isPdf && !isJpgOrPng) {
      message.error('El formato del archivo no está permitido.');
    }
    const isLt10M =
      file.size /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 /
        1024 <
      2;
    if (!isLt10M) {
      message.warning('El tamaño de la imagen debe ser inferior a 10MB.');
    }
    setLoadingImagen(false);
    return (isPdf || isJpgOrPng) && isLt10M;
  }

  const uploadFileDoc = async (file, type, setter, setLoadingUpload) => {
    try {
      setLoading(true);
      setLoadingUpload(true);
      getBase64(file.file, (imageUrl) => {
        setter({
          imagen: imageUrl,
          extension: file.file.type.split('/')[1],
          nombre: `${type}.${file.file.type.split('/')[1]}`
        });
        setLoadingUpload(false);
      });
    } catch (error) {
      errorHandler(error, 'Error al subir el archivo');
      setLoadingUpload(false);
    }
  };
  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPreguntas = (detalle) => {
    const preguntas = detalle.split('.');
    return (
      <ul style={{ textAlign: 'left' }}>
        {preguntas.map((e, i) => {
          if (i !== preguntas.length - 1) return <li>{e}</li>;
          return '';
        })}
      </ul>
    );
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  const getAutorizacion = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(`/autorizacion/${token}`);
      setAutorizacion(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  const getLabelTipoVerificacion = (tipo) => {
    if (tipo === 'MONTO') return 'SUMA ASEGURADA TOTAL';
    if (tipo === 'MONTOITEM') return 'ITEM DE COBERTURA';
    if (tipo === 'RETROACTIVIDAD') return 'VIGENCIA';
    return tipo;
  };

  const getSolicitud = async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `/solicitud/${autorizacion.solicitud.token}`
      );
      setSolicitud(response.data.data);
      if (response.data.data.solicitante) {
        setSolicitante(JSON.parse(response.data.data.solicitante));
      }

      const responseDocumentos = await instanceRef.instance.get(
        `/solicitud/files/${response.data.data.token}`
      );
      // const baseURL = CONFIG.URL_BASE;
      const docs = responseDocumentos.data.data.map((item) => ({
        ...item,
        token: response.data.data.token
        // url: `${baseURL}/solicitud/file/${response.data.data.token}?id=${item.id}`
      }));
      setDocumentos(docs);

      const files = await instanceRef.instance.post(
        `form/documentos?token=${autorizacion.solicitud.token}&autorizacion=true`,
        {}
      );

      if (files.data.data && files.data.data.length === 0) {
        message.error('No se han encontrado los documentos');
        setLoading(false);
      } else {
        setFormularios(
          files.data.data
            .map(({ filename, content }) => ({
              filename: getDescripcionDocumento(filename),
              content
            }))
            .filter(
              ({ filename }) =>
                filename === 'Propuesta' || filename === 'Formulario'
            )
        );
        setLoading(false);
      }

      return response.data.data;
    } catch (err) {
      errorHandler(err, err.message);
      setLoading(false);
      return null;
    }
  };

  const getCotizacion = async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.post(
        `cotizacion/id?id=${autorizacion.id_cotizacion}`
      );
      setCotizaciones(response.data.data);
      setLoading(false);
      return response.data.data;
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
      return null;
    }
  };

  const getAseguradoraProducto = async (producto, aseguradora) => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `aseguradoraproducto/aseguradora/${aseguradora}/producto/${producto}`
      );
      setAseguradoraProducto(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  const DocumentoUpload = ({
    name,
    customLoading,
    setLoadingUpload,
    setDocumento
  }) => (
    <div style={{ height: 150 }}>
      <Dragger
        name={name}
        accept={formatosDoc}
        listType="picture-card"
        className={`avatar-uploader ${customLoading ? 'success' : 'error'}`}
        showUploadList={false}
        customRequest={(e) =>
          uploadFileDoc(e, name, setDocumento, setLoadingUpload)
        }
        beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        disabled
      >
        <div>
          {customLoading && <LoadingOutlined style={{ fontSize: 18 }} />}
          {!customLoading && (
            <>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p
                className="ant-upload-text"
                style={{ width: '150px', margin: 'auto' }}
              >
                Click o arrastrar archivo para subir
              </p>
            </>
          )}
        </div>
      </Dragger>
    </div>
  );
  const uploadFileDocAdicional = async (file, type) => {
    try {
      setLoading(true);
      getBase64(file.file, (imageUrl) => {
        const archivo = {
          imagen: imageUrl,
          extension: file.file.type.split('/')[1],
          nombre: `${type}.${file.file.type.split('/')[1]}`
        };
        setDocumentosAdicionales([...documentosAdicionales, archivo]);
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
      errorHandler(error, 'Error al subir el archivo');
    }
  };

  const ButtonExtraFile = () => {
    if (documento1)
      return (
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosDoc}
          showUploadList={false}
          customRequest={(e) => uploadFileDocAdicional(e, `documento4`)}
          beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        >
          <div>
            <Card
              cover={
                <Button type="dashed" shape="round">
                  <FileAddOutlined /> Agregar Documento adicional
                </Button>
              }
              bodyStyle={{ padding: '0' }}
              style={{
                border: 0,
                marginBottom: 20
              }}
            />

            <div className="background-hover" />
          </div>
        </Upload>
      );
    return <></>;
  };

  const DocumentCard = ({
    name,
    customLoading,
    setLoadingUpload,
    documento,
    setDocumento
  }) => (
    <Card
      bodyStyle={{ padding: '0px' }}
      cover={
        <div>
          {customLoading && <LoadingOutlined style={{ fontSize: 18 }} />}
          {!customLoading && (
            <>
              {documento ? (
                <>
                  {documento.extension !== 'pdf' && (
                    <Card
                      bodyStyle={{ height: 200, width: 141, padding: '0px' }}
                    >
                      <Image360
                        src={documento.imagen}
                        alt="avatar"
                        style={{
                          maxWidth: 140,
                          height: 195,
                          objectFit: 'contain'
                        }}
                      />
                    </Card>
                  )}{' '}
                  {documento.extension === 'pdf' && (
                    <CardDocumentPreview360
                      cardProps={{
                        onClick: () => {
                          setDialogConfig({
                            open: true,
                            content: documento.imagen,
                            title: ''
                          });
                        }
                      }}
                      documentProps={{
                        file: documento.imagen,
                        onLoadSuccess: onDocumentLoadSuccess
                      }}
                    />
                  )}
                </>
              ) : null}
            </>
          )}
        </div>
      }
      actions={[
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosDoc}
          showUploadList={false}
          customRequest={(e) =>
            uploadFileDoc(e, name, setDocumento, setLoadingUpload)
          }
          beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        >
          <EditOutlined />
        </Upload>
      ]}
    />
  );

  const DocumentCardAdicional = ({ index }) => (
    <Card
      bodyStyle={{ padding: '0px' }}
      cover={
        <div>
          {loadingBefore && <LoadingOutlined style={{ fontSize: 18 }} />}
          {!loadingBefore && (
            <>
              {documentosAdicionales[index] ? (
                <>
                  {documentosAdicionales[index].extension !== 'pdf' && (
                    <Card
                      bodyStyle={{ height: 200, width: 141, padding: '0px' }}
                    >
                      <Image360
                        src={documentosAdicionales[index].imagen}
                        alt="avatar"
                        style={{
                          maxWidth: 140,
                          height: 200,
                          objectFit: 'contain'
                        }}
                      />
                    </Card>
                  )}{' '}
                  {documentosAdicionales[index].extension === 'pdf' && (
                    <CardDocumentPreview360
                      cardProps={{
                        onClick: () => {
                          setDialogConfig({
                            open: true,
                            content: documentosAdicionales[index].imagen,
                            title: ''
                          });
                        }
                      }}
                      documentProps={{
                        file: documentosAdicionales[index].imagen,
                        onLoadSuccess: onDocumentLoadSuccess
                      }}
                    />
                  )}
                </>
              ) : null}
            </>
          )}
        </div>
      }
      actions={[
        <Upload
          style={{ width: 'auto !important' }}
          accept={formatosDoc}
          showUploadList={false}
          customRequest={(e) =>
            uploadFileDocAdicional(e, `documento${index + 2}`, index)
          }
          beforeUpload={(e) => beforeUploadPDF(e, setLoadingBefore)}
        >
          <EditOutlined />
        </Upload>,
        <DeleteOutlined onClick={() => {}} />
      ]}
    />
  );

  const preview = useCallback(() => {
    if (documento1)
      return (
        <DocumentCard
          name="documento1"
          loading={loading1}
          setLoadingUpload={setLoading1}
          documento={documento1}
          setDocumento={setDocumento1}
        />
      );
    return (
      <DocumentoUpload
        label="Tipo de documento"
        name="documento1"
        loading={loading1}
        setLoadingUpload={setLoading1}
        setDocumento={setDocumento1}
      />
    );
  }, [documento1, loading1, setDocumento1]);

  const previewAdicional = useCallback(
    (index) => {
      if (documentosAdicionales[index])
        return <DocumentCardAdicional index={index} />;
      return <></>;
    },
    [documentosAdicionales]
  );

  const toVerify = async (autorizacionId) => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.post(
        `/autorizacion/actualizar/${autorizacionId}`,
        {
          token: autorizacion.token,
          estado: 'VERIFICADO',
          comentario: comentarioDet
        }
      );
      if (response.status === 205) {
        await message.warning('¡Asignación con límite excedido!');
        window.location.reload();
      }
      setAutorizacion(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  const toApprove = async (autorizacionId) => {
    try {
      const toUpdateAutorizacion = { ...form };
      if (observacionAutorizacionDatos) {
        const comentarios = toUpdateAutorizacion.comentario
          ? `Verificador: ${toUpdateAutorizacion.comentario}`
          : '';

        const comentarioFinal = `${comentarios}\nObs.: ${observacionAutorizacionDatos}`;

        toUpdateAutorizacion.comentario = comentarioFinal;
      }
      setLoading(true);
      const response = await instanceRef.instance.post(
        `/autorizacion/actualizar/${autorizacionId}`,
        { token, estado: 'APROBADO', ...toUpdateAutorizacion }
      );

      if (response.status === 205) {
        await message.warning('¡Asignación con límite excedido!');
        window.location.reload();
      }
      setAutorizacion(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  const toReject = async (autorizacionId) => {
    try {
      setLoading(true);

      const toUpdateAutorizacion = { ...form };
      const response = await instanceRef.instance.post(
        `/autorizacion/actualizar/${autorizacionId}`,
        { token, estado: 'RECHAZADO', ...toUpdateAutorizacion }
      );
      if (response.status === 205) {
        await message.warning('¡Asignación con límite excedido!');
        window.location.reload();
      }
      setAutorizacion(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  const toArchive = async (autorizacionId) => {
    try {
      setLoading(true);
      await instanceRef.instance.post(
        `/autorizacion/archive/${autorizacionId}`,
        { token, comentario: comentarioDet }
      );
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  /* const puedeVisualizar = () => {
    let sucursal = true;
    let empresa = true;
    let aseguradora = true;
    if (autorizacion && usuario && usuario.sucursal) {
      sucursal = usuario.sucursal.id === autorizacion.id_sucursal;
    }

    if (autorizacion && usuario && usuario.empresa) {
      empresa = usuario.empresa.id === autorizacion.id_empresa;
    }

    if (autorizacion && usuario && usuario.aseguradora) {
      aseguradora = usuario.aseguradora.id === autorizacion.id_aseguradora;
    }
    return sucursal && empresa && aseguradora;
  }; */

  const asignarUsuario = async () => {
    try {
      setLoading(true);
      await instanceRef.instance.post(`/autorizacion/asignar/${token}`);
      setAsignacion(!asignacion);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  };

  /* const getUsuario = async () => {
    try {
      setLoading(true);
      const response = await instanceRef.instance.get(
        `/usuarios/${user.sub}/usuario`
      );
      setUsuario(response.data.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandler(err, err.message);
    }
  }; */

  const getColor = (estado) => {
    if (estado === 'APROBADO') return 'green';
    if (estado === 'RECHAZADO') return 'red';
    if (estado === 'PENDIENTE') return 'yellow';
    if (estado === 'ARCHIVADO') return 'lightgray';
    return 'green';
  };

  const condicionParaAsignar = () => {
    if (!window.location.href.includes('view')) asignarUsuario();
    else getAutorizacion();
  };

  const updateSolicitudPersona = async (personaDatosActuales) => {
    const solicitanteJson = JSON.parse(solicitud.solicitante);
    const datosModificados = true;
    /* compareJSONObjects(
      personaDatosActuales,
      solicitanteJson.persona
    ); */
    if (datosModificados) {
      const newSolicitante = {
        ...solicitanteJson,
        persona: {
          ...solicitanteJson.persona,
          ...personaDatosActuales
        }
      };
      // update persona, add persona_historial, update solicitud->solicitante
      try {
        const response = await instanceRef.instance.post(
          `solicitud/autorizacion/${solicitud.token}`,
          {
            solicitante: newSolicitante,
            editado: {
              aseguradoraid:
                solicitud.cotizacion.aseguradoraEmpresa.id_aseguradora
            },
            tipo: 'PERSONA'
          }
        );
        if (response.data?.data) {
          return true;
        }
      } catch (error) {
        errorHandler(error, error.message);
        return false;
      }
    }

    return false;
  };

  const updateSolicitudTercero = async (autorizacionCurrent) => {
    // Compare the current fiscal data with the existing solicitud data
    const fiscalDatosActuales = formFiscal.getFieldsValue().emision;
    const datosModificados = true;
    /* compareJSONObjects(fiscalDatosActuales, {
      ruc: solicitud.tercero.ruc,
      razonSocial: solicitud.tercero.nombres
    }); */

    if (datosModificados) {
      const newSolicitante = null;
      try {
        const response = await instanceRef.instance.post(
          `solicitud/autorizacion/${solicitud.token}`,
          {
            solicitante: newSolicitante,
            tercero: {
              ...autorizacionCurrent.detalle?.fiscal?.tercero,
              ruc: fiscalDatosActuales.ruc,
              nombres: fiscalDatosActuales.razonSocial
            },
            tipo: 'FISCAL'
          }
        );

        if (response.data?.data) {
          return true; // Return true cuando la actualizacion fue existosa
        }
      } catch (error) {
        errorHandler(error, error.message);
        return false;
      }
    }

    return false; // Return false si no se realizaron cambios
  };

  const updateSolicitudVehiculo = async (vehiculoDatosActuales) => {
    const { vehiculo } = solicitud.cotizacion;

    const datosModificados = compareJSONObjects(
      vehiculoDatosActuales,
      vehiculo
    );
    if (datosModificados) {
      // update vehiculo, add vehiculo_historial
      try {
        const response = await instanceRef.instance.post(
          `solicitud/autorizacion/${solicitud.token}`,
          {
            vehiculo: { ...vehiculo, ...vehiculoDatosActuales },
            editado: {
              aseguradoraid:
                solicitud.cotizacion.aseguradoraEmpresa.id_aseguradora
            },
            tipo: 'VEHICULO'
          }
        );
        if (response.data?.data) {
          return true;
        }
      } catch (error) {
        errorHandler(error, error.message);
        return false;
      }
    }

    return false;
  };

  const cargarObservaciones = (idAutorizacion) => {
    const autorizacionAActualizar = autorizacion.autorizaciones.find(
      (item) => item.id === idAutorizacion
    );
    const sistemaCoreRequiereRevision =
      autorizacionAActualizar.detalle?.persona?.sistemaCore?.requiereRevision;

    if (sistemaCoreRequiereRevision) {
      /* let observacionConcat =
        'Inconsistencia de datos del Sistema Core y Datos para Emisión de: ';
      const sistemaCoreRequiereRevisionList = Object.keys(
        sistemaCoreRequiereRevision
      );

      for (let i = 0; i < sistemaCoreRequiereRevisionList.length; i += 1) {
        const sistemaCore = sistemaCoreRequiereRevisionList[i];

        // Utilizaremos una variable auxiliar para almacenar los campos a concatenar
        let camposRevisar = '';

        if (sistemaCore.key === 'nombres') {
          camposRevisar += ' Nombres';
        }
        if (sistemaCore.key === 'fechaNacimiento') {
          camposRevisar += ' Fecha de Nacimiento';
        }
        if (sistemaCore.key === 'sexo') {
          camposRevisar += ' Sexo';
        }
        if (sistemaCore.key === 'estadoCivil') {
          camposRevisar += ' Estado Civil';
        }

        // Ahora, verificamos si hay campos a concatenar antes de modificar observacionConcat
        if (camposRevisar !== '') {
          observacionConcat += camposRevisar;
        }
      } */
      const mensajeObs =
        autorizacionAActualizar.detalle?.persona?.sistemaCore?.alertaTexto ||
        '';
      setObservacionesAutorizacionDatos(mensajeObs);
    }
  };

  const updateAutorizacionDatos = async (autorizacionParams) => {
    try {
      let autorizacionNew = autorizacionParams;
      let datosActualizados = false;
      if (autorizacionParams.detalle?.persona && formPersonal) {
        if (formPersonal) {
          const personaDatosActuales = FormPersonalDatosActualizados;
          const datosModidficadosPersona = await updateSolicitudPersona(
            personaDatosActuales
          );

          if (datosModidficadosPersona) {
            autorizacionNew = {
              ...autorizacionNew,
              detalle: {
                ...autorizacionNew.detalle,
                persona: {
                  ...autorizacionNew.detalle.persona,
                  emision: {
                    ...autorizacionNew.detalle.persona.emision,
                    ...personaDatosActuales,
                    actualizado: true
                  }
                }
              }
            };
            datosActualizados = true;
          } else if (
            !autorizacionParams.detalle?.persona?.emision?.actualizado
          ) {
            autorizacionNew = {
              ...autorizacionNew,
              detalle: {
                ...autorizacionNew.detalle,
                persona: {
                  ...autorizacionNew.detalle.persona,
                  emision: {
                    ...autorizacionNew.detalle.persona.emision,
                    actualizado: true
                  }
                }
              }
            };
            datosActualizados = true;
          }
        }
      }

      if (autorizacionParams.detalle?.fiscal) {
        if (formFiscal) {
          const fiscalDatosActuales = FormFiscalDatosActualizados;
          const datosModificadosFiscal = await updateSolicitudTercero(
            autorizacionParams
          );
          if (datosModificadosFiscal) {
            autorizacionNew = {
              ...autorizacionNew,
              detalle: {
                ...autorizacionNew.detalle,
                fiscal: {
                  ...autorizacionNew.detalle?.fiscal,
                  emision: {
                    ...autorizacionNew.detalle?.fiscal?.emision,
                    ...fiscalDatosActuales,
                    actualizado: true
                  }
                }
              }
            };
            datosActualizados = true;
          } else if (
            !autorizacionParams.detalle?.fiscal?.emision?.actualizado
          ) {
            autorizacionNew = {
              ...autorizacionNew,
              detalle: {
                ...autorizacionNew.detalle,
                fiscal: {
                  ...autorizacionNew.detalle?.fiscal,
                  emision: {
                    ...autorizacionNew.detalle?.fiscal?.emision,
                    actualizado: true
                  }
                }
              }
            };
            datosActualizados = true;
          }
        }
      }

      if (autorizacionParams.detalle?.vehiculo) {
        if (formVehiculo) {
          const vehiculoDatosActuales = FormVehiculoDatosActualizados;
          const datosModidficadosVehiculo = await updateSolicitudVehiculo(
            vehiculoDatosActuales
          );

          if (datosModidficadosVehiculo) {
            autorizacionNew = {
              ...autorizacionNew,
              detalle: {
                ...autorizacionNew.detalle,
                vehiculo: {
                  ...autorizacionNew.detalle.vehiculo,
                  emision: {
                    ...autorizacionNew.detalle.vehiculo.emision,
                    ...vehiculoDatosActuales,
                    actualizado: true
                  }
                }
              }
            };
            datosActualizados = true;
          } else if (
            !autorizacionParams.detalle?.vehiculo?.emision?.actualizado
          ) {
            autorizacionNew = {
              ...autorizacionNew,
              detalle: {
                ...autorizacionNew.detalle,
                vehiculo: {
                  ...autorizacionNew.detalle.vehiculo,
                  emision: {
                    ...autorizacionNew.detalle.vehiculo.emision,
                    actualizado: true
                  }
                }
              }
            };
            datosActualizados = true;
          }
        }
      }

      if (datosActualizados) {
        await instanceRef.instance.put(
          `/autorizacion/detalle/${autorizacionNew.id}`,
          {
            autorizacion: { ...autorizacionNew }
          }
        );

        await getAutorizacion();
        if (autorizacionParams.detalle?.persona) {
          await cargarObservaciones(autorizacionNew.id);
        }
      }
      message.success('Actualizado correctamente');

      setLoading(false);
    } catch (error) {
      errorHandler(error, error.message);
    }
  };

  const handleConfirm = async (autorizacionParams) => {
    const observacionConcat =
      'Los datos del Asegurado del Sistema Core no fueron validados';
    /* for (let i = 0; i < sistemaCoreRequiereRevisionList.length; i += 1) {
      const sistemaCore = sistemaCoreRequiereRevisionList[i];

      // Utilizaremos una variable auxiliar para almacenar los campos a concatenar
      let camposRevisar = '';

      if (sistemaCore.key === 'nombres') {
        camposRevisar += ' Nombres';
      }
      if (sistemaCore.key === 'fechaNacimiento') {
        camposRevisar += ' Fecha de Nacimiento';
      }
      if (sistemaCore.key === 'sexo') {
        camposRevisar += ' Sexo';
      }
      if (sistemaCore.key === 'estadoCivil') {
        camposRevisar += ' Estado Civil';
      }

      // Ahora, verificamos si hay campos a concatenar antes de modificar observacionConcat
      if (camposRevisar !== '') {
        observacionConcat += camposRevisar;
      }
    } */

    setVisible(false);
    await updateAutorizacionDatos(autorizacionParams);
    setHabilitarBotonAprobar(true);
    setDatosConfirmados(true);
    setObservacionesAutorizacionDatos(observacionConcat);
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const handleConfirmarDatos = async (autorizacionParams) => {
    if (datosConfirmados) {
      setDatosConfirmados(false);
      setHabilitarBotonAprobar(false);
      return;
    }
    setFormPersonalDatosActualizados(formPersonal.getFieldsValue().emision);
    setFormVehiculoDatosActualizados(formVehiculo.getFieldsValue().emision);
    setFormFiscalDatosActualizados(formFiscal.getFieldsValue().emision);

    try {
      if (formPersonal && formPersonal.getFieldsValue()) {
        await formPersonal.validateFields();
      }
      if (formFiscal && formFiscal.getFieldsValue()) {
        await formFiscal.validateFields();
      }
      if (formVehiculo && formVehiculo.getFieldsValue()) {
        await formVehiculo.validateFields();
      }
    } catch (error) {
      message.warning('Completá todos los campos requeridos.');
      return;
    }

    if (
      formPersonal &&
      formPersonal.getFieldsValue() &&
      (autorizacionParams.detalle?.persona?.sistemaCore?.requiereRevision ||
        autorizacionParams.detalle?.persona?.sistemaCore?.alertaTexto)
    ) {
      setVisible(true);
    } else {
      await updateAutorizacionDatos(autorizacionParams);
      setHabilitarBotonAprobar(true);
      setDatosConfirmados(true);
    }
  };

  const DetalleAutorizacion = ({ tipo, detalle, a }) => {
    return (
      <>
        {(tipo === 'MONTO' || tipo === 'MONTOITEM' || tipo === 'DESCUENTO') &&
          detalle.message.map((e, i, { length }) => {
            let texto = '';
            if (tipo === 'MONTO') {
              texto = (
                <>
                  <span>{e.message}</span>
                  <div>
                    {length - 1 === i && e.rango_hasta !== '-1' && (
                      <span>
                        Las Sumas Aseguradas entre {e.rango_desde || 'N/A'} -{' '}
                        {e.rango_hasta || 'N/A'} están sujetas a Autorización
                      </span>
                    )}
                    {length - 1 === i && e.rango_hasta === '-1' && (
                      <span>
                        Las Sumas Aseguradas mayores a {e.rango_desde || 'N/A'}{' '}
                        están sujetas a Autorización
                      </span>
                    )}
                  </div>
                </>
              );
            } else if (tipo === 'MONTOITEM') {
              texto = (
                <>
                  <>
                    <span>{e.message} - </span>
                    <span style={{ fontWeight: 'bold' }}>
                      Item de Cobertura solicitado por ejecutivo:{' '}
                    </span>
                    <span>
                      {e.itemCobertura.cobertura?.coberturaItem?.descripcion ||
                        'N/A'}
                    </span>
                  </>
                  {length - 1 === i && (
                    <div>
                      <span>{e.detalle}</span>
                    </div>
                  )}
                </>
              );
            } else {
              texto = (
                <>
                  <span>{e.message} - </span>
                  <span>
                    Descuentos entre {e.rango_desde || 'N/A'} -{' '}
                    {e.rango_hasta || 'N/A'} están sujetos a Autorización
                  </span>
                </>
              );
            }

            return (
              <div style={{ display: 'flex', justifyContent: 'left' }}>
                <Badge
                  align="left"
                  color="red"
                  status="processing"
                  text={texto}
                />
              </div>
            );
          })}
        {tipo === 'CUMULO' && (
          <Badge
            align="left"
            color="red"
            status="processing"
            text={detalle.message}
          />
        )}
        <div style={{ textAlign: 'start' }}>
          {tipo !== 'CUESTIONARIO' &&
            tipo !== 'MONTO' &&
            tipo !== 'MONTOITEM' &&
            tipo !== 'CUMULO' &&
            tipo !== 'DESCUENTO' && (
              <Badge
                align="left"
                color="red"
                status="processing"
                text={detalle.message}
              />
            )}
        </div>

        {tipo === 'CUESTIONARIO' && (
          <Badge
            align="left"
            color="red"
            status="processing"
            text="Control Cuestionario"
          />
        )}
        {tipo === 'CUESTIONARIO' && getPreguntas(detalle.message)}
        {tipo === 'VEHICULO' && (
          <div>
            <span style={{ fontWeight: 'bold' }} />
            Descuentos / Recargos:
            <span />
            <span /> {detalle.descuentosRecargos}
            <span />
          </div>
        )}
        {tipo === 'ZONA' && (
          <div>
            <span style={{ fontWeight: 'bold' }} />
            Descuentos / Recargos:
            <span />
            <span /> {detalle.descuentosRecargos}
            <span />
          </div>
        )}
        {tipo === 'DATOS' && (
          <div
            style={{
              textAlign: 'center',
              margin: 'auto'
            }}
          >
            <br />
            {solicitud && (
              <>
                {detalle?.persona && (
                  <>
                    <Divider />
                    <Title
                      level={5}
                      align="left"
                      style={{ marginBottom: '10px' }}
                    >
                      Datos del Asegurado
                    </Title>
                    <AutorizacionDatos
                      autorizacion={a}
                      idAseguradora={
                        solicitud.cotizacion.aseguradoraEmpresa.id_aseguradora
                      }
                      datosConfirmados={datosConfirmados}
                      setDatosConfirmados={setDatosConfirmados}
                      setHabilitarBotonAprobar={setHabilitarBotonAprobar}
                      form={formPersonal}
                    />
                    <br />
                  </>
                )}
                {detalle?.fiscal && (
                  <>
                    <Divider />
                    <Title
                      level={5}
                      align="left"
                      style={{ marginBottom: '10px' }}
                    >
                      Datos Fiscales
                    </Title>

                    <AutorizacionDatosFiscal
                      autorizacion={a}
                      datosConfirmados={datosConfirmados}
                      setDatosConfirmados={setDatosConfirmados}
                      setHabilitarBotonAprobar={setHabilitarBotonAprobar}
                      form={formFiscal}
                    />
                  </>
                )}
                {detalle?.vehiculo && (
                  <>
                    <Divider />
                    <Title
                      level={5}
                      align="left"
                      style={{ marginBottom: '10px' }}
                    >
                      Datos del Vehículo
                    </Title>
                    <AutorizacionDatosVehiculo
                      autorizacion={a}
                      datosConfirmados={datosConfirmados}
                      setDatosConfirmados={setDatosConfirmados}
                      setHabilitarBotonAprobar={setHabilitarBotonAprobar}
                      form={formVehiculo}
                    />
                    <br />
                  </>
                )}
                {autorizacion.estado === 'PENDIENTE' && (
                  <>
                    <Button
                      type="primary"
                      icon={<SaveOutlined />}
                      onClick={() => handleConfirmarDatos(a)}
                    >
                      {datosConfirmados ? 'Editar de nuevo' : 'Confirmar Datos'}
                    </Button>
                  </>
                )}

                {/* Modal de alerta para confirmacion de datos */}
                <Modal
                  title="Confirmar Datos"
                  open={visible}
                  onOk={() => handleConfirm(a)}
                  onCancel={handleCancel}
                  okText="Confirmar"
                  cancelText="Cancelar"
                >
                  <p>
                    {`Está seguro que desea realizar esta acción?. ${
                      detalle?.persona?.sistemaCore?.alertaTexto || ''
                    }`}
                  </p>
                </Modal>
              </>
            )}

            <br />
          </div>
        )}
      </>
    );
  };

  const getIndices = (autorizacionFlujo, a) => {
    const indexRolUsuario = ORDEN_ESTADOS_VERIFICACION_AUTORIZACION[
      autorizacionFlujo.estado_general
    ].findIndex((elem) => user && elem === user['cognito:groups'][0]);

    const estadoVerificacion =
      a.estado_verificacion ===
      ORDEN_ESTADOS_VERIFICACION_AUTORIZACION[
        autorizacionFlujo.estado_general
      ][0]
        ? ORDEN_ESTADOS_VERIFICACION_AUTORIZACION[
            autorizacionFlujo.estado_general
          ][1]
        : a.estado_verificacion;
    const indexNivel = ORDEN_ESTADOS_VERIFICACION_AUTORIZACION[
      autorizacionFlujo.estado_general
    ].findIndex((elem) => elem === estadoVerificacion);

    return {
      indexRolUsuario,
      indexNivel
    };
  };

  useEffect(() => {
    const load = async () => {
      if (autorizacion && autorizacion.id_solicitud) {
        const solicitudResponse = await getSolicitud();
        await getAseguradoraProducto(
          solicitudResponse.cotizacion.id_producto,
          autorizacion.id_aseguradora
        );
      } else if (autorizacion && autorizacion.id_cotizacion) {
        const cotizacionResponse = await getCotizacion();
        await getAseguradoraProducto(
          cotizacionResponse[0].id_producto,
          autorizacion.id_aseguradora
        );
      }
    };
    load();
  }, [autorizacion]);

  useEffect(() => {
    condicionParaAsignar();
  }, []);

  /* useEffect(() => {
    if (user) getUsuario();
  }, [user]); */

  useEffect(() => {
    if (asignacion) getAutorizacion();
  }, [asignacion]);

  return (
    <ResponsiveContainer>
      <Card style={{ minHeight: 200 }}>
        <Spin
          spinning={loading}
          delay={500}
          size="large"
          tip="Cargando..."
          style={{ minHeight: 100 }}
        >
          {autorizacion && (
            <p
              level={5}
              style={{ justifyContent: 'center', display: 'flex', gap: 8 }}
            >
              <span style={{ fontWeight: 'bold' }}>
                {`Flujo de autorización en estado: `}
              </span>{' '}
              <Tag color={getColor(autorizacion.estado)}>
                {autorizacion.estado}
              </Tag>
            </p>
          )}
          {autorizacion && solicitud && (
            <Solicitud
              solicitud={solicitud}
              solicitante={solicitante}
              documentos={documentos}
              formularios={formularios}
            />
          )}
          {autorizacion && cotizaciones && (
            <Cotizacion cotizaciones={cotizaciones} />
          )}

          {autorizacion?.autorizaciones.length > 0 && (
            <>
              <Title level={4} align="left" style={{ marginTop: '20px' }}>
                Autorizaciones Pendientes
              </Title>
              <Collapse
                style={{ marginTop: 20, marginBottom: 20 }}
                expandIconPosition="end"
              >
                {autorizacion.autorizaciones.map((a, index) => {
                  const { tieneCantidadParaAprobacion } = a.permisos;
                  const { tieneSuperUser } = a.permisos; // Aprobador gerencial
                  const { tienePermisoEspecial } = a.permisos; // autorización especial
                  const ultimoRol =
                    user &&
                    a.permisos.ultimoRolCadena === user['cognito:groups'][0];

                  const indices = getIndices(autorizacion, a);

                  const esUsuarioNivelSuperior =
                    indices.indexRolUsuario >= indices.indexNivel;

                  const usuarioYaVerificoAprobo = a.autorizacionDetalles.find(
                    (detalle) =>
                      (detalle.estado === 'VERIFICADO' ||
                        detalle.estado === 'APROBADO' ||
                        detalle.estado === 'RECHAZADO') &&
                      user &&
                      detalle.usuario &&
                      detalle.usuario.id_cognito === user.sub
                  );

                  const esUsuarioAsignado =
                    user && a.usuario && user.sub === a.usuario.id_cognito;

                  const fechaProcesamiento = a.fecha_procesamiento;
                  let ultimaAsignacion = '';

                  if (fechaProcesamiento) {
                    const diff = moment.duration(
                      moment().diff(fechaProcesamiento)
                    );

                    const segundos = diff.asSeconds().toFixed(0);
                    const minutos = diff.asMinutes().toFixed(0);
                    const horas = diff.asHours().toFixed(0);
                    const dias = diff.asDays().toFixed(0);

                    if (minutos >= 60) {
                      if (horas > 24) {
                        ultimaAsignacion = `Última asignación hace ${dias} día/s`;
                      } else {
                        ultimaAsignacion = `Última asignación hace ${horas} hora/s`;
                      }
                    } else if (minutos === 0) {
                      ultimaAsignacion = `Última asignación hace ${segundos} segundo/s`;
                    } else {
                      ultimaAsignacion = `Última asignación hace ${minutos} minuto/s`;
                    }
                  }
                  return (
                    <Panel
                      header={
                        <>
                          <Row
                            justify="space-between"
                            align="center"
                            style={{ alignItems: 'center' }}
                          >
                            <Col
                              md={6}
                              xs={6}
                              align="left"
                              style={{ display: 'flex' }}
                            >
                              <span style={{ flexGrow: 1, fontWeight: 'bold' }}>
                                {getLabelTipoVerificacion(a.tipo_validacion)}
                              </span>
                            </Col>
                            {a.usuario && (
                              <Col
                                md={15}
                                xs={13}
                                style={{
                                  textAlign: 'left'
                                }}
                              >
                                <span>
                                  Esta autorización está asignada a{' '}
                                  {a.usuario.nombres}
                                </span>
                                <br />
                                <span style={{ fontWeight: 'bold' }}>
                                  {ultimaAsignacion}
                                </span>
                              </Col>
                            )}
                            {!a.usuario && (
                              <Col
                                md={15}
                                xs={13}
                                style={{
                                  textAlign: 'right'
                                }}
                              >
                                Autorización no asignada
                              </Col>
                            )}
                            <Col>
                              <Tag
                                color={getColor(a.estado)}
                                md={3}
                                xs={3}
                                style={{
                                  textAlign: 'right'
                                }}
                              >
                                {a.estado}
                              </Tag>
                            </Col>
                          </Row>
                        </>
                      }
                      key={index}
                    >
                      <Title level={5} align="left">
                        Detalles
                      </Title>
                      <DetalleAutorizacion
                        tipo={a.tipo_validacion}
                        detalle={a.detalle}
                        a={a}
                      />
                      <Divider />
                      <Title
                        level={5}
                        align="left"
                        style={{ marginBottom: '10px' }}
                      >
                        Cadena de Aprobaciones Pendientes
                      </Title>

                      {a.revisiones && (
                        <table
                          className="simple-table"
                          style={{
                            borderSpacing: 8,
                            textAlign: 'start',
                            marginBottom: '20px',
                            display: 'block',
                            overflow: 'auto'
                          }}
                        >
                          <tbody>
                            <tr
                              style={{
                                backgroundColor: '#fafafa',
                                height: '40px',
                                border: '1px solid #f0f0f0',
                                fontSize: '14px'
                              }}
                            >
                              <th style={{ textAlign: 'left' }}>Grupo</th>
                              <th
                                style={{
                                  border: '1px solid #f0f0f0',
                                  textAlign: 'left'
                                }}
                              >
                                Rol
                              </th>
                              <th
                                style={{
                                  border: '1px solid #f0f0f0',
                                  textAlign: 'right'
                                }}
                              >
                                Cantidad
                              </th>
                              <th
                                style={{
                                  border: '1px solid #f0f0f0',
                                  textAlign: 'right'
                                }}
                              >
                                Verificado
                              </th>
                            </tr>
                            {a.aC.id_empresa_producto && (
                              <>
                                <tr
                                  style={{
                                    border: '1px solid #f0f0f0',
                                    height: '40px'
                                  }}
                                >
                                  <td
                                    rowSpan="3"
                                    style={{
                                      backgroundColor: '#fafafa',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    Empresa
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      backgroundColor: '#fafafa',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    Gerente Empresa
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {' '}
                                    {a.revisiones.ADMIN_EMPRESA
                                      ? a.revisiones.ADMIN_EMPRESA.cantidad
                                      : 0}
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {a.revisiones.ADMIN_EMPRESA
                                      ? a.revisiones.ADMIN_EMPRESA.verificado
                                      : 0}
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    border: '1px solid #f0f0f0',
                                    height: '40px'
                                  }}
                                >
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      backgroundColor: '#fafafa',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    Gerente Sucursal
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {' '}
                                    {a.revisiones.ADMIN_SUCURSAL
                                      ? a.revisiones.ADMIN_SUCURSAL.cantidad
                                      : 0}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: 'right'
                                    }}
                                  >
                                    {' '}
                                    {a.revisiones.ADMIN_SUCURSAL
                                      ? a.revisiones.ADMIN_SUCURSAL.verificado
                                      : 0}
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    border: '1px solid #f0f0f0',
                                    height: '40px'
                                  }}
                                >
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      backgroundColor: '#fafafa',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    Ejecutivo
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {' '}
                                    {a.revisiones.EJECUTIVO
                                      ? a.revisiones.EJECUTIVO.cantidad
                                      : 0}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: 'right'
                                    }}
                                  >
                                    {' '}
                                    {a.revisiones.EJECUTIVO
                                      ? a.revisiones.EJECUTIVO.verificado
                                      : 0}
                                  </td>
                                </tr>
                              </>
                            )}
                            {(a.aC.id_aseguradora_producto ||
                              a.aC.id_aseguradora_empresa_producto) && (
                              <>
                                <tr
                                  style={{
                                    border: '1px solid #f0f0f0',
                                    height: '40px'
                                  }}
                                >
                                  <td
                                    rowSpan="2"
                                    style={{
                                      backgroundColor: '#fafafa'
                                    }}
                                  >
                                    Aseguradora
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor: '#fafafa',
                                      border: '1px solid #f0f0f0'
                                    }}
                                  >
                                    Gerente Aseguradora
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {a.revisiones.ADMIN_ASEGURADORA
                                      ? a.revisiones.ADMIN_ASEGURADORA.cantidad
                                      : 0}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: 'right'
                                    }}
                                  >
                                    {a.revisiones.ADMIN_ASEGURADORA
                                      ? a.revisiones.ADMIN_ASEGURADORA
                                          .verificado
                                      : 0}
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    border: '1px solid #f0f0f0',
                                    height: '40px'
                                  }}
                                >
                                  <td
                                    style={{
                                      backgroundColor: '#fafafa',
                                      border: '1px solid #f0f0f0'
                                    }}
                                  >
                                    Ejecutivo Aseguradora
                                  </td>
                                  <td
                                    style={{
                                      border: '1px solid #f0f0f0',
                                      textAlign: 'right'
                                    }}
                                  >
                                    {a.revisiones.EJECUTIVO_ASEGURADORA
                                      ? a.revisiones.EJECUTIVO_ASEGURADORA
                                          .cantidad
                                      : 0}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: 'right'
                                    }}
                                  >
                                    {a.revisiones.EJECUTIVO_ASEGURADORA
                                      ? a.revisiones.EJECUTIVO_ASEGURADORA
                                          .verificado
                                      : 0}
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      )}

                      <Title
                        level={5}
                        align="left"
                        style={{ marginBottom: '20px', marginTop: '20px' }}
                      >
                        Historial de Cambios y Aprobaciones
                      </Title>
                      {autorizacion && a.autorizacionDetalles && (
                        <Historial
                          autorizacionesDet={a.autorizacionDetalles}
                          mode="left"
                        />
                      )}
                      {autorizacion &&
                        a.tipo_validacion === 'DESCUENTO' &&
                        autorizacion.estado === 'PENDIENTE' &&
                        a.permisos &&
                        (tieneCantidadParaAprobacion ||
                          tieneSuperUser ||
                          (tienePermisoEspecial &&
                            ultimoRol &&
                            tieneCantidadParaAprobacion)) && (
                          <Title
                            level={5}
                            align="left"
                            style={{ marginBottom: '30px' }}
                          >
                            Gestión de Aprobación{' '}
                          </Title>
                        )}
                      {aseguradoraProducto &&
                        autorizacion &&
                        autorizacion.estado === 'PENDIENTE' &&
                        !a.estado_verificacion.includes('VERIFICADO') && (
                          <Form
                            name="gestion_aprobacion"
                            layout="horizontal"
                            initialValues={{
                              tecnico: solicitud
                                ? solicitud.reajuste || 0
                                : cotizaciones[0].reajuste || 0,
                              administrativo: 0,
                              gastos_administrativos: 0,
                              utilidad: 0,
                              comision: 0,
                              gastos_cobranzas: 0
                            }}
                            onFinish={(values) => {
                              setForm(values);
                              if (accion.includes('APROBAR'))
                                setModalContent({
                                  title: 'Autorizar',
                                  tipo: 'APROBAR',
                                  okText: 'Aprobar',
                                  id: a.id
                                });
                              else if (accion.includes('RECHAZAR'))
                                setModalContent({
                                  title: 'Rechazar',
                                  tipo: 'RECHAZAR',
                                  okText: 'Rechazar',
                                  id: a.id
                                });
                              else if (accion.includes('VERIFICAR'))
                                setModalContent({
                                  title: 'Verificar',
                                  tipo: 'VERIFICAR',
                                  okText: 'Enviar Verificación',
                                  id: a.id
                                });
                              setIsModalOpen(true);
                            }}
                          >
                            <Row style={{ textAlign: 'start' }}>
                              {a.permisos &&
                                ((esUsuarioAsignado &&
                                  tieneCantidadParaAprobacion) ||
                                  tieneSuperUser ||
                                  (tienePermisoEspecial &&
                                    ultimoRol &&
                                    tieneCantidadParaAprobacion)) &&
                                !window.location.href.includes('view') &&
                                !usuarioYaVerificoAprobo && (
                                  <Col xs={24} md={24}>
                                    {' '}
                                    {a.tipo_validacion === 'DESCUENTO' && (
                                      <div>
                                        <Title style={{ fontSize: '15px' }}>
                                          Ajuste de Costos tipo (%):
                                        </Title>
                                        <table
                                          style={{
                                            textAlign: 'start',
                                            width: '100%'
                                          }}
                                        >
                                          <tbody>
                                            <tr
                                              style={{
                                                display: 'flex',
                                                alignItems: 'baseline',
                                                height: '35px'
                                              }}
                                            >
                                              <td style={{ width: '250px' }}>
                                                Tasa
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item name="tasa">
                                                  <InputNumber
                                                    min={0}
                                                    max={100}
                                                    disabled
                                                  />
                                                </Form.Item>
                                              </td>
                                            </tr>
                                            <tr
                                              style={{
                                                display: 'flex',
                                                alignItems: 'baseline',
                                                height: '35px'
                                              }}
                                            >
                                              <td style={{ width: '250px' }}>
                                                Descuento/Recargo
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item name="descuento_recargo">
                                                  <InputNumber
                                                    min={0}
                                                    max={100}
                                                    disabled
                                                  />
                                                </Form.Item>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <Title
                                          style={{
                                            fontSize: '15px',
                                            marginTop: '20px'
                                          }}
                                        >
                                          Diferencia respecto a Notas Técnicas
                                          Aplicar a (%):{' '}
                                        </Title>
                                        <table
                                          className="simple-table"
                                          style={{
                                            textAlign: 'start',
                                            width: '100%'
                                          }}
                                          border="1px solid #f0f0f0"
                                        >
                                          <tbody>
                                            <tr
                                              style={{
                                                backgroundColor: '#fafafa',
                                                height: '40px',
                                                border: '1px solid #f0f0f0',
                                                fontSize: '14px'
                                              }}
                                            >
                                              <th>Descuentos / Recargos</th>
                                              <th>Sub-item</th>
                                              <th>% Actual</th>
                                              <th>% Solicitado</th>
                                              <th>% Total</th>
                                            </tr>
                                            <tr
                                              style={{
                                                border: '1px solid #f0f0f0',
                                                height: '40px'
                                              }}
                                            >
                                              <td
                                                style={{
                                                  backgroundColor: '#fafafa',
                                                  fontWeight: 'bold'
                                                }}
                                              >
                                                Técnico
                                              </td>
                                              <td />
                                              <td>
                                                {
                                                  aseguradoraProducto.descuentos_recargos_tecnicos
                                                }
                                              </td>
                                              <td style={{ width: '10%' }}>
                                                {' '}
                                                <Form.Item
                                                  name="tecnico"
                                                  style={{ margin: 0 }}
                                                  onChange={(e) =>
                                                    setDescuentosRecargosTecnicos(
                                                      e.target.value -
                                                        aseguradoraProducto.descuentos_recargos_tecnicos
                                                    )
                                                  }
                                                >
                                                  <InputNumber
                                                    style={{ width: '100%' }}
                                                  />
                                                </Form.Item>
                                              </td>
                                              <td>
                                                {descuentosRecargosTecnicos}
                                              </td>
                                            </tr>
                                            <tr
                                              style={{
                                                border: '1px solid #f0f0f0',
                                                height: '40px'
                                              }}
                                            >
                                              {' '}
                                              <td
                                                style={{
                                                  backgroundColor: '#fafafa',
                                                  fontWeight: 'bold'
                                                }}
                                              >
                                                Administrativo
                                              </td>
                                              <td />
                                              <td>
                                                {
                                                  aseguradoraProducto.descuentos_recargos_administrativos
                                                }
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item
                                                  name="administrativo"
                                                  style={{ margin: 0 }}
                                                  onChange={(e) =>
                                                    setDescuentosRecargosAdministrativos(
                                                      e.target.value -
                                                        aseguradoraProducto.descuentos_recargos_administrativos
                                                    )
                                                  }
                                                >
                                                  <InputNumber
                                                    disabled
                                                    min={0}
                                                    max={100}
                                                    style={{ width: '100%' }}
                                                  />
                                                </Form.Item>
                                              </td>
                                              <td>
                                                {
                                                  descuentosRecargosAdministrativos
                                                }
                                              </td>{' '}
                                            </tr>
                                            <tr
                                              style={{
                                                border: '1px solid #f0f0f0',
                                                height: '40px'
                                              }}
                                            >
                                              {' '}
                                              <td
                                                rowSpan="4"
                                                style={{
                                                  backgroundColor: '#fafafa',
                                                  fontWeight: 'bold'
                                                }}
                                              >
                                                Explotación
                                              </td>
                                              <td>Gastos Administrativos</td>
                                              <td>
                                                {
                                                  aseguradoraProducto.gastos_administrativos
                                                }
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item
                                                  name="gastos_administrativos"
                                                  style={{ margin: 0 }}
                                                  onChange={(e) =>
                                                    setGastosAdministrativos(
                                                      e.target.value -
                                                        aseguradoraProducto.gastos_administrativos
                                                    )
                                                  }
                                                >
                                                  <InputNumber
                                                    disabled
                                                    min={
                                                      aseguradoraProducto.gastos_administrativos
                                                    }
                                                    max={100}
                                                    style={{ width: '100%' }}
                                                  />
                                                </Form.Item>
                                              </td>
                                              <td>{gastosAdministrativos}</td>{' '}
                                            </tr>
                                            <tr
                                              style={{
                                                border: '1px solid #f0f0f0',
                                                height: '40px'
                                              }}
                                            >
                                              {' '}
                                              <td>Utilidad</td>
                                              <td>
                                                {aseguradoraProducto.utilidad}
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item
                                                  name="utilidad"
                                                  style={{ margin: 0 }}
                                                  onChange={(e) => {
                                                    setUtilidad(
                                                      e.target.value -
                                                        aseguradoraProducto.utilidad
                                                    );
                                                  }}
                                                >
                                                  <InputNumber
                                                    disabled
                                                    min={
                                                      aseguradoraProducto.utilidad
                                                    }
                                                    max={100}
                                                    style={{ width: '100%' }}
                                                  />
                                                </Form.Item>
                                              </td>{' '}
                                              <td>{utilidad}</td>{' '}
                                            </tr>
                                            <tr
                                              style={{
                                                border: '1px solid #f0f0f0',
                                                height: '40px'
                                              }}
                                            >
                                              {' '}
                                              <td>Comisión Agente</td>
                                              <td>
                                                {aseguradoraProducto.comision}
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item
                                                  name="comision"
                                                  style={{ margin: 0 }}
                                                  onChange={(e) =>
                                                    setComision(
                                                      e.target.value -
                                                        aseguradoraProducto.comision
                                                    )
                                                  }
                                                >
                                                  <InputNumber
                                                    disabled
                                                    min={0}
                                                    max={100}
                                                    style={{ width: '100%' }}
                                                  />
                                                </Form.Item>
                                              </td>{' '}
                                              <td>{comision}</td>{' '}
                                            </tr>
                                            <tr
                                              style={{
                                                border: '1px solid #f0f0f0',
                                                height: '40px'
                                              }}
                                            >
                                              {' '}
                                              <td>Gastos de Cobranza</td>
                                              <td>
                                                {
                                                  aseguradoraProducto.gastos_cobranzas
                                                }
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item
                                                  name="gastos_cobranzas"
                                                  style={{ margin: 0 }}
                                                  onChange={() =>
                                                    setGastosCobranzas(
                                                      form.getFieldValue(
                                                        'gastos_cobranzas'
                                                      ) -
                                                        aseguradoraProducto.gastos_cobranzas
                                                    )
                                                  }
                                                >
                                                  <InputNumber
                                                    disabled
                                                    min={0}
                                                    max={100}
                                                    style={{ width: '100%' }}
                                                  />
                                                </Form.Item>
                                              </td>{' '}
                                              <td>{gastosCobranzas}</td>{' '}
                                            </tr>
                                          </tbody>
                                        </table>
                                        <Title
                                          style={{
                                            fontSize: '15px',
                                            marginTop: '20px'
                                          }}
                                        >
                                          Costo Final a ser presentado a Cliente
                                          (%):
                                        </Title>
                                        <table
                                          style={{
                                            textAlign: 'start',
                                            width: '100%'
                                          }}
                                        >
                                          <thead>
                                            <tr />
                                          </thead>
                                          <tbody>
                                            <tr
                                              style={{
                                                display: 'flex',
                                                alignItems: 'baseline',
                                                height: '35px'
                                              }}
                                            >
                                              <td style={{ width: '250px' }}>
                                                Contado
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item name="contado">
                                                  <InputNumber
                                                    min={0}
                                                    max={100}
                                                    disabled
                                                  />
                                                </Form.Item>
                                              </td>
                                            </tr>
                                            <tr
                                              style={{
                                                display: 'flex',
                                                alignItems: 'baseline',
                                                height: '35px'
                                              }}
                                            >
                                              <td style={{ width: '250px' }}>
                                                Fraccionado
                                              </td>
                                              <td>
                                                {' '}
                                                <Form.Item name="fraccionado">
                                                  <InputNumber
                                                    min={0}
                                                    max={100}
                                                    disabled
                                                  />
                                                </Form.Item>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div style={{ marginBottom: '30px' }}>
                                          <Title
                                            style={{
                                              fontSize: '15px',
                                              marginTop: '20px'
                                            }}
                                          >
                                            Adjuntar Archivos:
                                          </Title>
                                          <Row
                                            justify="center"
                                            style={{ textAlign: 'start' }}
                                          >
                                            <Col>{preview()}</Col>
                                            {documentosAdicionales.map(
                                              (documento, i) => (
                                                <Col
                                                  style={{ marginLeft: '5px' }}
                                                  key={i}
                                                >
                                                  {previewAdicional(i)}
                                                </Col>
                                              )
                                            )}
                                          </Row>
                                          <Row style={{ marginTop: '20px' }}>
                                            <Col xs={24} md={8}>
                                              {ButtonExtraFile()}
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    )}
                                    <br />
                                    <Col xs={24} md={24}>
                                      <Form.Item
                                        label="Comentario interno"
                                        name="comentario"
                                      >
                                        <TextArea
                                          placeholder="Escribir comentario"
                                          rows={4}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Col>
                                )}
                              <Divider />
                              {a.permisos &&
                                !window.location.href.includes('view') &&
                                !usuarioYaVerificoAprobo &&
                                (esUsuarioAsignado ||
                                  tieneSuperUser ||
                                  (tienePermisoEspecial &&
                                    esUsuarioNivelSuperior)) && (
                                  <Col xs={24} md={24} align="center">
                                    {(tieneCantidadParaAprobacion ||
                                      tieneSuperUser ||
                                      (tienePermisoEspecial &&
                                        ultimoRol &&
                                        tieneCantidadParaAprobacion)) &&
                                    !a.estado_verificacion.includes(
                                      'VERIFICADO'
                                    ) ? (
                                      <Space>
                                        <Button
                                          htmlType="submit"
                                          onClick={() => setAccion('RECHAZAR')}
                                        >
                                          Rechazar
                                        </Button>
                                        <Button
                                          type="primary"
                                          htmlType="submit"
                                          onClick={() => setAccion('APROBAR')}
                                          disabled={!habilitarBotonAprobar}
                                        >
                                          Aprobar
                                        </Button>
                                      </Space>
                                    ) : (
                                      <Space>
                                        <Button
                                          type="primary"
                                          htmlType="submit"
                                          onClick={() => setAccion('VERIFICAR')}
                                        >
                                          Verificar
                                        </Button>
                                      </Space>
                                    )}
                                  </Col>
                                )}
                            </Row>
                          </Form>
                        )}
                      <Modal
                        bodyStyle={{ padding: 0, paddingBottom: 20 }}
                        style={{ maxWidth: 1000 }}
                        className="modal-header-document"
                        centered
                        open={dialogConfig.open}
                        afterClose={() =>
                          setDialogConfig({
                            open: false,
                            content: undefined,
                            title: ''
                          })
                        }
                        onCancel={() =>
                          setDialogConfig({
                            open: false,
                            content: undefined,
                            title: ''
                          })
                        }
                        footer={null}
                        width="90%"
                      >
                        <div>
                          {dialogConfig.content && (
                            <SizeMe>
                              {({ size }) => (
                                <Document
                                  onLoadSuccess={onDocumentLoadSuccess}
                                  loading={<Spin />}
                                  file={dialogConfig.content}
                                >
                                  <Page
                                    key={`page_${currentPage + 1}`}
                                    pageNumber={currentPage + 1}
                                    width={size.width ? size.width : 1}
                                  />
                                  <div style={{ textAlign: 'center' }}>
                                    <Button
                                      type="link"
                                      onClick={() => previousPage()}
                                      disabled={currentPage === 0}
                                    >
                                      <LeftOutlined />
                                      Anterior
                                    </Button>
                                    Pág. {currentPage + 1} de {numPages}
                                    <Button
                                      type="link"
                                      onClick={() => nextPage()}
                                      disabled={currentPage + 1 === numPages}
                                    >
                                      Siguiente
                                      <RightOutlined />
                                    </Button>
                                  </div>
                                </Document>
                              )}
                            </SizeMe>
                          )}
                        </div>
                      </Modal>
                    </Panel>
                  );
                })}
              </Collapse>
            </>
          )}
        </Spin>
        <Modal
          title={modalContent.title}
          open={isModalOpen}
          onOk={() => {
            if (modalContent.tipo === 'ARCHIVAR') toArchive(modalContent.id);
            if (modalContent.tipo === 'VERIFICAR') toVerify(modalContent.id);
            if (modalContent.tipo === 'APROBAR') toApprove(modalContent.id);
            if (modalContent.tipo === 'RECHAZAR') toReject(modalContent.id);
            setIsModalOpen(false);
          }}
          okText={modalContent.okText}
          onCancel={() => {
            setIsModalOpen(false);
          }}
        >
          {modalContent.tipo === 'VERIFICAR' ||
          modalContent.tipo === 'ARCHIVAR' ? (
            <Row>
              <Col xs={24}>
                <p>
                  ¿Desea agregar un comentario?
                  <Switch
                    checked={showComentario}
                    onChange={(value) => {
                      setShowComentario(value);
                    }}
                    style={{ marginLeft: '10px' }}
                  />
                </p>
              </Col>
              <Col xs={24}>
                {showComentario && (
                  <TextArea
                    placeholder="Escribir comentario"
                    value={comentarioDet}
                    rows={4}
                    onChange={(e) => {
                      setComentarioDet(e.target.value);
                    }}
                  />
                )}
              </Col>
            </Row>
          ) : (
            <Row>
              <Col xs={24}>
                <p>
                  ¿Está seguro? Una vez autorizado el flujo continuará su
                  proceso
                </p>
              </Col>
            </Row>
          )}
        </Modal>
      </Card>
      {/*! puedeVisualizar() && (
        <Result
          status="403"
          title="No Autorizado"
          subTitle="Lo sentimos, no tienes autorización para acceder a esta página"
          extra={[
            <Button
              type="primary"
              key="console"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Ir al inicio
            </Button>
          ]}
        />
        ) */}
    </ResponsiveContainer>
  );
};

export default AutorizacionVerify;
